import * as React from "react";
import SvgSplitScreen from "../components/SvgSplitScreen";
import settings from "../styles/global/settings";
import Layout from "../components/Layout/Layout";
import PropTypes from "prop-types";
import Image from "../svg/loops.svg";
import { SCREENS } from "../helpers/screen-names-helper";

const NearlyThereFoodScreen = ({
  onClick,
  onBackClick,
}: PropTypes.InferProps<
  typeof NearlyThereFoodScreen.propTypes
>): JSX.Element => {
  const buttons = [
    {
      title: `Continue`,
      onClick: () => onClick(),
      showBack: true,
      onBackClick: () => onBackClick(),
    },
  ];
  return (
    <Layout
      segmentTitle={SCREENS.NearlyThereScreen}
      buttons={buttons}
      backgroundColor={settings.color.path}
    >
      <SvgSplitScreen
        backgroundColor={settings.color.primary_4}
        svg={<Image />}
      >
        <h4>We’re nearly there!</h4>
        <p>You’re one step closer to finding your perfect health plan.</p>
        <p>
          The key to any health journey is sticking with it, so it’s super
          important we find something that suits you...
        </p>
        <p style={{ fontWeight: "bold" }}>Let&apos;s go!</p>
      </SvgSplitScreen>
    </Layout>
  );
};

NearlyThereFoodScreen.propTypes = {
  onClick: PropTypes.func,
  onBackClick: PropTypes.func,
};

export default NearlyThereFoodScreen;
